function CalculateCombinePrice() {

    var CombineSubTotal = 0;
    var FreeCargoLimit = parseFloat($("#FreeCargoLimit").val().replace(",", "."));

    $(".CombineColors input.SizeID").each(function (index) {
        if ($(this).closest(".CombineColors").next().find("a.SizeLink.active").length > 0) {
            var CombineItemPriceAmount = parseFloat($(this).closest(".CombineItemRow").find(".CombineItemAmount").attr("data-amount").replace(",", "."));
            CombineSubTotal += CombineItemPriceAmount;
        }
    });

    var CombineSubTotalString = String(CombineSubTotal.toFixed(2)).replace(".", ",");
    $(".CombineSelectedPrice").html(CombineSubTotalString);

    if (CombineSubTotal >= FreeCargoLimit) {
        $(".BottomFreeCargoInfo").slideDown("slow");
    }
    else {
        $(".BottomFreeCargoInfo").slideUp("slow");
    }
}


function RunSlickSlider() {


    if ($('.NewPD.Combines').length > 0) {


        if ($('.ProductDetailImages ul li').length > 0) {

            $(".VideoArea").closest("li").remove();
            $(".DownloadImage").remove();

            $('.ProductDetailImages ul li img').each(function () {
                if ($(this).attr("data-src") != undefined && $(this).attr("data-src") != "") {
                    $(this).attr("src", $(this).attr("data-src"));
                }
            });



           


            /*$slc = */
            $('.ProductDetailImages ul').slick({
                centerMode: false,
                prevArrow: "<img class='PrdImgLeft' src='/Images/PRS/left.png' style='width:auto; height:auto'/>",
                nextArrow: "<img class='PrdImgRight' src='/Images/PRS/right.png' style='width:auto; height:auto' />",
            });


            $('.SmallProductImages').slick({
                slidesToShow: 5,
                vertical: false,
                slidesToScroll: 1,
                asNavFor: '.ProductDetailImages ul',
                focusOnSelect: true
                //centerMode: false
            });


            $ItemIndex = $('.ProductDetailImages ul li.slick-current').data("slick-index");
            $(".SmallProductImages img").each(function (x) {
                var Item = $(this)
                if (Item.index() == $ItemIndex) {
                    Item.addClass("Selected");
                }
            });
            $(".SmallProductImages").hide();
        }

        if ($(".PdIcons > div").length <= 0) $(".PdIcons").hide();


    }
}



function MobileAddCombineToBasketScrollEvent() {

    if ($(window).width() < 767) {

        $(window).scroll(function (event) {
            var y = $(this).scrollTop();

            if (y >= 250) {
                $(".AddCombineToBasket").slideDown("slow");

            } else {
                $(".AddCombineToBasket").slideUp("slow");
            }
        });
    }
}

$(document).ready(function () {
    RunSlickSlider();
    MobileAddCombineToBasketScrollEvent();

    $miniImage = $(".SmallProductImages");

    //RunSlickSlider();

    // $slc.slick("slickGoTo", $("#ImageAngle").val() - 1, true);

    if (!isMobileResolution) {
        $miniImage.slick("slickGoTo", $("#ImageAngle").val() - 1, true);
    }

    //SEPETE EKLE TEK TEK
    $(".AddCombineItemToBasket").on("click", function (e) {
        // $(".AddToBasket button").append("<i class='BasketsIcon hidden-xs hidden-sm'></i>");

        var SizeID = $(this).parent().parent().parent().find(".CombineColors .SizeID").val();
        var ColorID = $(this).parent().parent().parent().find(".CombineColors .ColorID").val();
        var ProductID = $(this).parent().parent().parent().find(".CombineColors .ProductID").val();
        var Amount = "1";
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        //console.log('sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID);
        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.attr("title");
            var AddingText = "Ekleniyor...";
            $basketButton.find("span").html(AddingText);

            $.ajax({
                type: 'get',
                url: getRequestRoute() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    $basketButton.html("<span>" + NormalText + "</span>");
                    $basketButton.addClass("BasketActive");

                    //alert(NormalText);

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {
                        GetSepetIcerik(function (dt) {
                            $("#UserAndBasket").html(dt);

                            //if (!isMobileResolution() {
                            //    toggleBasket();
                            //}

                            toggleBasket();

                            // 5 sn. sonra kapansın                                
                            setTimeout(function () {
                                if ($("body").hasClass("BasketDropped")) {
                                    toggleBasket();
                                }
                            }, 5000);
                        });
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                    }

                }
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                if ($(".NewPD").length <= 0) {
                    alert(BedenSec);
                } else {
                    $("#PrdBlackBg").show();
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("PleaseSelect");
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("singleSelect");
                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {
                alert(RenkSec);

                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);
        }

        e.preventDefault();
        return false;
    });

    //SEPETE EKLE TÜMÜ
    $(".AddCombineToBasket #Basket").on("click", function () {
        //console.log("1");
        var SizeError = "";
        var ColorError = "";
        var Amount = 1; //$(".CombineAmountOptions #Amount").val();
        //console.log(Amount);
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var ItemOnly = $(this).hasClass("AddCombineItemToBasket");
        $basketButton = $(this);

        $Inputs = $(".CombineColors input");

        if (ItemOnly) {
            //console.log("2");
            $(".AddPleaseSelect").removeClass("PleaseSelect AddPleaseSelect");
            $Inputs = $(this).closest(".ProductName").next(".CombineColors").find("input");
        }

        $Inputs.each(function (index) {
            //console.log("3");
            if ($(this).hasClass("SizeID")) {
                var sizeIDValue = $(this).val();

                if ($("a.SizeLink.active").length <= 0) {

                    SizeError = BedenSec;
                    $(this).closest(".CombineColors").next().addClass("AddPleaseSelect");
                    $(".PrdBlackBg").css("display", "block");
                }

                if ((sizeIDValue == undefined || sizeIDValue == "") && $(this).closest(".CombineColors").next().find("a.SizeLink").length > 0) {

                    //SizeError = BedenSec; 
                    // $(this).closest(".CombineColors").next().addClass("AddPleaseSelect");
                }
            }

            if ($(this).hasClass("ColorID")) {
                //console.log("4");
                var colorIDValue = $(this).val();

                if (colorIDValue == undefined || colorIDValue == "") {
                    ColorError = RenkSec;
                }
            }
        });
        //console.log(SizeError);
        //console.log(ColorError);
        if (SizeError == "" && ColorError == "") // SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != ""
        {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            //console.log("5");
            $basketButton.text(AddingText);
            //var params = $("#ProductCombineContent").find("input").serialize() + "&adet=" + Amount + "&langID=" + LangID;
            //console.log(params);
            $.ajax({
                type: 'get',
                url: getRequestRoute() + "/p/Cart/AddCombineToCart",
                data: $("#ProductCombineContent").find("input").serialize() + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    //alert(url);
                    $basketButton.text(NormalText);

                    //alert(dt.Sonuc + dt.IslemSonucAciklama);
                    //console.log("6");
                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);


                    if (dt.Sonuc == true) {
                        GetSepetIcerik(function (dt) {
                            $("#UserAndBasket").html(dt);

                            //if (!isMobileResolution() {
                            //    toggleBasket();
                            //}

                            toggleBasket();

                            // 5 sn. sonra kapansın                                
                            setTimeout(function () {
                                if ($("body").hasClass("BasketDropped")) {
                                    toggleBasket();
                                }
                            }, 5000);
                        });
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                    }
                }
            });
        }
        else {
            if (SizeError != "") {
                if ($(".NewPD").length <= 0) {
                    alert(BedenSec);
                } else {
                    $("#PrdBlackBg").show();
                    $(".AddPleaseSelect .CombineSizeOptions.open").addClass("PleaseSelect");
                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorError != "") {
                alert(RenkSec);

                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }
        }
    });

    //Combine Size Selection
    $('.CombineSizeOptions a').live("click", function () {
        $combineSizes = $(this).parents(".CombineSizes");
        $combineColors = $combineSizes.prev();

        if ($(this).hasClass("active")) {
            $combineSizes.find(".Name").html("");
            $combineColors.find(".SizeID").val("");
            $(this).removeClass("active");

        }
        else {
            $(this).parents(".CombineSizeOptions").find("a").removeClass("active");
            $combineSizes.find(".Name").html($(this).attr("data-name"));
            $combineColors.find(".SizeID").val($(this).attr("data-id"));

            $(this).parent().find("a").removeClass("active");
            $(this).addClass("active");

            if ($(".NewPD").length > 0) {

                $combineSizes.find(".CombineSizeOptions").addClass("passed");
                $(".CombineSizeAndAmount span.ChooseTitle ").addClass("passed");
                $combineColors.find("span.ChooseTitle").removeClass("current");
                $combineColors.find("span.ChooseTitle").addClass("passed");
                $combineSizes.find("span.ChooseTitle").removeClass("current");
                $combineSizes.find("span.ChooseTitle").addClass("passed");
                $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
                $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");
                $(".AmountOptions  span.ChooseTitle").removeClass("passed");
                $(".AmountOptions  span.ChooseTitle").addClass("current");
                $(".AmountOptions").addClass("open");

                var isAllSizesSelected = true;
                var TrigAddBasket = false;

                if ($(".CombineSizeOptions.PleaseSelect").length == 1) {
                    TrigAddBasket = true;
                }

                if ($(".AutoTextRep").length > 0) {

                    if (isAllSizesSelected) {
                        $(".AddCombineToBasket button").removeClass("NotSelected");
                        $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
                        $(".CombineSizeOptions").removeClass("PleaseSelect");
                        $("#PrdBlackBg").hide();

                        if (TrigAddBasket) {
                            $(".AddCombineToBasket #Basket").click();
                        }
                    }
                }
            }
        }

        var SelectedSizeCount = $("a.SizeLink.active").length;
        $(".CombineSelected").html(SelectedSizeCount);

        CalculateCombinePrice();
    });


    $('.ProductDetail .CombineColors a').on("click", function () {
        //RunSlickSlider();
        $combineColors = $(this).closest(".CombineColors");
        $combineSizes = $combineColors.next(".CombineSizes").first();

        $combineItemRow = $(this).closest(".CombineItemRow");
        $('#RemindModal .modal-body .alert-error').hide();
        $('#RemindModal .modal-body .remind-success').hide();
        $('.RemindInfo').show();

        $combineColors.find(".Name").html($(this).attr("data-name"));
        $combineColors.find(".ColorID").val($(this).attr("data-id"));
        $combineColors.find(".SizeID").val("");

        var ProductID = $combineColors.find(".ProductID").val();

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");

        $combineColors.find(".SizeID").val("");

        $(".AjaxLoader").show();

        var params = "ColorID=" + $(this).attr("data-id") + "&ProductID=" + ProductID;
        var lastColorID = 0;


        // ürün detay sayfasına giden link'in güncellenmesi
        var linkUrl = '#go-product-detaill-link-' + $(this).attr('data-productid');
        $(linkUrl).attr("href", $(this).attr('data-product-detail-url'));

        //console.log($(this).attr('data-product-detail-url'));
        //console.log($(this));

        if (lastColorID != $(this).attr("data-id")) {
            lastColorID = $(this).attr("data-id");

            if ($(".ProductHeader #ProductID").length > 0) {

                var newhash = "#C=" + $(this).attr("data-id");
                window.location.hash = newhash;
            }

            $.ajax({
                type: "GET",
                url: getRequestRoute() + "/p/ProductDetails/GetAllDetailInfoByColorID",
                data: params,
                success: function (data) {
                    $selectSizePopup = $(".CombineSizeOptions .SelectSizePopup:first");

                    if ($selectSizePopup.length > 0) {
                        $selectSizePopup = $(".CombineSizeOptions .SelectSizePopup").clone();
                    }

                    $combineSizes.find(".CombineSizeOptions").html("");

                    if ($selectSizePopup.length > 0) {
                        $combineSizes.find(".CombineSizeOptions").append($selectSizePopup);
                    }

                    var imgCount = 0;

                    var ImageCount = data.filter(function (val) {
                        return val.Type === "StockImage";
                    });

                    if (ImageCount.length > 0) {

                        $('.ProductDetailImages ul').slick('unslick');
                        $('.ProductDetailImages ul li').remove();

                        $('.SmallProductImages').slick('unslick');
                        $('.SmallProductImages img').remove();

                        //return false;
                        //$(".SmallProductImages img").remove();
                        //$('.ProductDetailImages ul li.ImgArea').remove();
                        //$('.ProductDetailImages ul li.ImgArea').html("");
                        //$(".SmallProductImages img").html("");


                    }

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].Type == "Size") {
                            var stil = "";

                            var DisplayName = data[i].Name;

                            if (data[i].SizeValue != "" && data[i].SizeValue != null && data[i].SizeValue != undefined) {
                                DisplayName = data[i].SizeValue;
                            }

                            if (data[i].InStock == false || data[i].PStatus != 1) {
                                stil = "OutOfQuantity";
                                $('.AddToRemindList').show();
                            }
                            else {
                                $combineSizes.find(".CombineSizeOptions").append('<span><a data-id="' + data[i].ID + '" data-stock="' + data[i].InStock + '" data-name="' + data[i].Name + '" href="javascript:void(0)" class="SizeLink ' + stil + " " + data[i].Name + '">' + DisplayName + '</a></span>');
                            }

                            $(".AjaxLoader").hide();
                        }

                        if (data[i].Type == "StockImage") {

                            $imgKucuk = $('<img >');
                            $imgKucuk.attr('src', data[i].Name.replace("_buyuk", "_kucuk"));
                            $combineItemRow.find(".CombineItemImg img").remove();

                            if ($combineItemRow.find(".CombineItemImg img").attr("src") != data[i].Name.replace("_buyuk", "_kucuk")) {
                                $combineItemRow.find(".CombineItemImg").append($imgKucuk);
                                $imgKucuk.show("slow");
                            }

                            $(".SmallProductImages").prepend($imgKucuk.clone());


                            if (imgCount == 0) {
                                //$(".CombineItemImg img:first", $combineItemRow).trigger("click");
                            }

                            var srcAttr = "src";

                            if (imgCount == 0) {
                                //srcAttr = "data-src";
                            }

                            var $img = $('<img >');
                            $img.attr(srcAttr, data[i].Name.replace("_detay", "_enbuyuk"));

                            var $li = $('<li class="ImgArea fancybox">');

                            if (imgCount >= 1) {
                                $li.addClass("gizli");
                            }

                            //var $a = $('<a>');
                            //$a.attr('href', data[i].Name);
                            //$a.attr('class', "cloudzoomManuel cloud-zoom");

                            //$a.append();
                            $li.append($img);

                            $li.prependTo('.ProductDetailImages ul');
                            // $li.clone().prependTo($newul);

                            imgCount++;
                        }

                    }
                    if (isMobileResolution) {
                        //$('html, body').animate({
                        //    scrollTop: $(".CombineDetailImages").offset().top - 50
                        //}, 500);
                    }
                    RunSlickSlider();
                    if ($(window).width() > 767) {
                        $miniImage.slick('unslick');
                        //$slc.slick('unslick');
                        $(".SmallProductImages").slick('unslick');
                        $(".ProductDetailImages ul").slick('unslick');
                        RunSlickSlider();
                    }

                    // küçük slider resmi ile büyük slider resmi aynı olması için
                    $("#ProductsImages > .SmallProductImages button.slick-next").trigger("click");


                    $(".ProductDetailImages ul li").each(function () {
                        if ($(this).hasClass("slick-current")) {
                            var ClickedItem = $(this);
                            $(".SmallProductImages img").remove("Selected");
                            $(".SmallProductImages img").each(function () {
                                if ($(this).data("slick-index") == ClickedItem.data("slick-index")) {
                                    $(this).find("img").addClass("Selected");
                                }

                            });
                        }
                    });
                    //$miniImage.html('');
                    //$slc.slick('unslick');
                    //$(".SmallProductImages").slick('unslick');
                    //$(".ProductDetailImages ul").slick('unslick');



                    if ($(".NewPD").length > 0) {

                        $combineSizes.find(".CombineSizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

                        $combineSizes.find(".CombineColors span.ChooseTitle").removeClass("current");
                        $combineColors.find("span.ChooseTitle").addClass("passed");

                        $combineSizes.find(".CombineSizeAndAmount span.ChooseTitle").addClass("current");
                        $combineSizes.find(".CombineSizeAndAmount span.ChooseTitle").removeClass("passed");

                        $combineSizes.find(".Name").html("");

                        $(".AddToBasket button").addClass("NotSelected");

                        if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
                            $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
                        }
                    }
                },
                error: function () {
                    alert(getStandartMessages("BirHataOlustu"));
                }
            });
        }

        CalculateCombinePrice();
    });

    //ürün küçük resmine tıklandığında sol büyük galeride görüntüler.
    $(".CombineItemImg img").live("click", function () {

        $(this).parent().parent().find("a.active").trigger("click");
    });

    $(".SmallProductImages  img").live("click", function () {

        $(".SmallProductImages img").each(function () {
            if ($(this).hasClass("slick-current")) {
                $(this).addClass("Selected");
            }
            else {
                $(this).removeClass("Selected");
            }

        });
    });
    if (!isMobileResolution) {
        $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            // alert("change");
            $(".SmallProductImages").slick("slickGoTo", currentSlide);
            //alert("Slide --> " + currentSlide);

            $(".SmallProductImages img").each(function () {

                //$(this).addClass("slick-current");

                if ($(this).hasClass("slick-current")) {
                    $(this).addClass("Selected");

                    //alert($(this).index());
                }
                else {
                    $(this).removeClass("Selected");
                }

            });


        });
    }



    //ilk küçük resime tıklamayı tetikliyoruz. (küçük slider için)
    $("#ProductCombineContent > .CombineItemRow > .CombineItemImg:first img").parent().parent().find("a.active").trigger("click");

    //$(document).on("click", ".CombineDetails .SmallProductImages  img", function () {
    //    $(".CombineDetails .SmallProductImages  img").removeClass("Selected");
    //    $(this).addClass("Selected");
    //    var thatIndex = $(this).index();
    //    //console.log(thatIndex);
    //    $(".ProductDetailImages ul li").addClass("gizli");

    //    $(".CombineDetails .ProductDetailImages ul li").each(function () {
    //        if (thatIndex == $(this).index()) {
    //            $(this).removeClass("gizli");
    //        }
    //    });
    //});


    //ürün küçük resmine tıklandığında sol büyük galeride görüntüler.
    $(".CombineItemImg img").on("click", function () {
        $(this).parent().parent().find("a.active").trigger("click");
        //$(this).parent().parent().find("a.active").trigger("click");
        ////alert$(".ProductDetailImages ul img.sagOk").length);
    });

    //$(document).on("click", ".CombineDetails .SmallProductImages  img", function () {
    //    $(".CombineDetails .SmallProductImages  img").removeClass("Selected");
    //    $(this).addClass("Selected");
    //    var thatIndex = $(this).index();
    //    //console.log(thatIndex);
    //    $(".ProductDetailImages ul li").addClass("gizli");

    //    $(".CombineDetails .ProductDetailImages ul li").each(function () {
    //        if (thatIndex == $(this).index()) {
    //            $(this).removeClass("gizli");
    //        }
    //    });
    //});

    //$('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    //    // alert("change");
    //    $(".SmallProductImages").slick("slickGoTo", currentSlide);
    //    //alert("Slide --> " + currentSlide);
    //    $(".SmallProductImages img").each(function () {
    //        //$(this).addClass("slick-current");
    //        if ($(this).hasClass("slick-current")) {
    //            $(this).addClass("Selected");
    //            //alert($(this).index());
    //        }
    //        else {
    //            $(this).removeClass("Selected");
    //        }
    //    });
    //});

    //ilk küçük resime tıklamayı tetikliyoruz. (küçük slider için)
    //$("#ProductCombineContent > .CombineItemRow > .CombineItemImg:first img").parent().parent().find("a.active").trigger("click");



    //ürün küçük resmine tıklandığında sol büyük galeride görüntüler.
    //$(".CombineItemImg img").live("click", function () {

    //    $(this).parent().parent().find("a.active").trigger("click");


    //});

    //$(".SmallProductImages  img").live("click", function () {

    //    $(".SmallProductImages img").each(function () {
    //        if ($(this).hasClass("slick-current")) {
    //            $(this).addClass("Selected");
    //        }
    //        else {
    //            $(this).removeClass("Selected");
    //        }

    //    });
    //});



    //$('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    //    // alert("change");
    //    $(".SmallProductImages").slick("slickGoTo", currentSlide);
    //    //alert("Slide --> " + currentSlide);

    //    $(".SmallProductImages img").each(function () {

    //        //$(this).addClass("slick-current");

    //        if ($(this).hasClass("slick-current")) {
    //            $(this).addClass("Selected");

    //            //alert($(this).index());
    //        }
    //        else {
    //            $(this).removeClass("Selected");
    //        }

    //    });


    //});


    //ilk küçük resime tıklamayı tetikliyoruz. (küçük slider için)
    // $("#ProductCombineContent > .CombineItemRow > .CombineItemImg:first img").parent().parent().find("a.active").trigger("click");

});

//jQuery(window).load(function () {
//    $("#ProductsImages > .SmallProductImages button.slick-next").trigger("click");
//});